module.exports = __webpack_public_path__ + "static/media/cosentino-message.2bc61bc5.svg";